declare global {
  interface Window {
    hsConversationsSettings: any;
    HubSpotConversations: any;
    _hsp: any;
  }
}
const HUBSPOT_ENABLED = process.env.NEXT_PUBLIC_HUBSPOT_ENABLED === 'TRUE';

const HubSpot = {
  /**
   * should be called on each route change
   */
  refresh(): void {
    if (!HUBSPOT_ENABLED) return;
    window.HubSpotConversations?.widget.refresh();
  },

  /**
   * Configure hubspot visitor identity. Triggers widget refresh.
   */
  setVisitorId(email: string, token: string): void {
    if (!HUBSPOT_ENABLED) return;
    window.hsConversationsSettings = {
      identificationEmail: email,
      identificationToken: token,
    };

    // GOTCHA: logged in user will not be able to see any conversation history before logged in
    // https://community.hubspot.com/t5/APIs-Integrations/Visitor-Identification-API-and-window-HubSpotConversations/td-p/519435
    window.HubSpotConversations?.clear({ resetWidget: true });
  },

  /**
   * Remove hubspot visitor identity. Triggers widget reset (clears conversation history)
   * GOTCHA: without reloading the page the previus hubspot user session persist until another user is
   * logged in - even after clearing all hubspot cookies then reloaded the widget using official API.
   */
  clearVisitorId(): void {
    if (!HUBSPOT_ENABLED) return;
    // clear hubspot configured cookies so that after page reload the previous user session is not reused
    document.cookie
      .split('; ')
      .filter((it) => it.startsWith('__hs') || it.startsWith('hubspot'))
      .map((it) => it.split('=')[0])
      .forEach(
        (key) => (document.cookie = `${key}= ; path=/; expires=${new Date(0).toUTCString()}`),
      );

    HubSpot.setVisitorId('', '');
  },
};

export default HubSpot;
